module.exports = "/images/ingredients-7.png";